<template>
  <page-header-wrapper>
    <a-card :bordered="false" title="汇率配置（cny_to_usd）">
      <a-alert message="商品阶梯价只维护人民币；美元 = 人民币 × 本汇率。建议每月更新一次，修改后立即影响后台预览与入库的 USD 快照字段。" type="info" show-icon style="margin-bottom:24px" />
      <a-form-model :label-col="{ span: 4 }" :wrapper-col="{ span: 10 }">
        <a-form-model-item label="人民币兑美元">
          <a-input-number v-model="rate" :min="0.000001" :step="0.0001" :precision="6" style="width:220px" />
          <div class="hint">示例：0.14 表示 ¥100 ≈ $14</div>
        </a-form-model-item>
        <a-form-model-item label="预览">
          <div>¥ 100 → $ {{ preview(100) }}</div>
          <div>¥ 117 → $ {{ preview(117) }}</div>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 10, offset: 4 }">
          <a-button type="primary" :loading="saving" @click="save">保存汇率</a-button>
          <a-button style="margin-left:8px" @click="load">刷新</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { getExchangeRate, saveExchangeRate } from '@/api/dkmall/exchange-rate'

export default {
  name: 'DkExchangeRate',
  data() {
    return { rate: 0.14, saving: false }
  },
  created() { this.load() },
  methods: {
    load() {
      getExchangeRate().then(res => {
        this.rate = Number((res.data && res.data.rate) || 0.14)
      })
    },
    preview(cny) {
      return (Number(cny) * Number(this.rate || 0)).toFixed(2)
    },
    save() {
      if (!this.rate || this.rate <= 0) return this.$message.warning('汇率必须大于 0')
      this.saving = true
      saveExchangeRate(this.rate).then(() => {
        this.$message.success('汇率已保存')
        this.load()
      }).finally(() => { this.saving = false })
    }
  }
}
</script>

<style scoped>
.hint { color: #8c8c8c; font-size: 12px; margin-top: 4px; }
</style>
